import React, { useEffect, useState } from "react";
import { sendAppEvent, timeout } from "../../../../Utils";
import SVG from "react-inlinesvg";
import ThumbsUp from "../../shared/ThumbsUp";
import ThumbsDown from "../../shared/ThumbsDown";

import {
  StyledTDDecoy,
  StyledTDDecoyRight,
  StyledTDDecoyLeft,
  StyledTDDecoyMiddle,
  StyledTDDecoyHalf,
  StyledTDDecoyContainer,
  StyledGhost,
} from "./styles";

const ThumbsDownDecoy = ({
  content,
  setItems,
  items,
  rejected,
  setRejected,
  setAnimating,
  animating,
  setDecoyContent,
  decoyLeft,
  decoyTop,
}) => {
  const [broken, setBroken] = useState(false);
  const [ghost, setGhost] = useState("");
  const [killed, setKilled] = useState(false);

  useEffect(() => {
    handleThumbsDown();

    return function cleanup() {
      if (animating) setAnimating(false);
    };
  }, []);

  const ghostAscending = async () => {
    await timeout(175);
    setGhost("ascend");
    await timeout(225);
  };

  const ghostAscended = async () => {
    setGhost("ascending ascended");
    setKilled(true);
    await timeout(225);
  };

  const handleThumbsDown = async () => {
    setBroken(true);
      await Promise.all([
        ghostAscending().then(ghostAscended)
      ]);
      //remove item from list
      const newItems = items.filter((item, i) => {
        return content !== item;
      });

      setItems(newItems);
      setRejected([...rejected, content.toLowerCase()]);
      sendAppEvent("Brainstorm - Reject Card");
      setAnimating(false);
      setDecoyContent(null);
  };

  const isBroken = broken !== false;
  // killed className can only be "killed"
  const killedClassName = killed ? "killed" : "";

  return (
    <StyledTDDecoyContainer
      key={content}
      className={killedClassName}
      broken={isBroken}
      top={decoyTop}
      left={decoyLeft}
      contentLength={content.length}
    >
      <StyledGhost className={ghost}>
        <SVG src="/assets/brainstorm/ghost.svg" />
      </StyledGhost>
      <StyledTDDecoyHalf
        side="left"
        broken={isBroken}
        killed={killed}
      >
        <StyledTDDecoy side="left">
          <StyledTDDecoyLeft
            broken={isBroken}
            opacity={"0.3"}
          >
            <ThumbsDown
              color={isBroken ? "var(--icon-button-fill)" : "var(--icon-button-fill)"}
              opacity={isBroken ? "var(--icon-button-opacity)" : "var(--icon-button-opacity)"}
            />
          </StyledTDDecoyLeft>
          <StyledTDDecoyMiddle length={content.length}>
            <span>{content}</span>
          </StyledTDDecoyMiddle>
        </StyledTDDecoy>
      </StyledTDDecoyHalf>
      <StyledTDDecoyHalf
        side="right"
        broken={isBroken}
        killed={killed}
      >
        <StyledTDDecoy side="right">
          <StyledTDDecoyRight>
            <ThumbsUp
              color={"#000"}
              opacity={"0.3"}
            />
          </StyledTDDecoyRight>
          <StyledTDDecoyLeft>
            <ThumbsDown />
          </StyledTDDecoyLeft>
          <StyledTDDecoyMiddle length={content.length}>
            <span>{content}</span>
          </StyledTDDecoyMiddle>
        </StyledTDDecoy>
      </StyledTDDecoyHalf>
    </StyledTDDecoyContainer>
  );
};

export default ThumbsDownDecoy;
